import { useQuery } from "@tanstack/react-query";
import { getReservations } from "../api/reservationApi";
import { reservationKeys } from "../api/reservationKeys";

export const useReservations = () =>
  useQuery({
    queryKey: reservationKeys.list(),
    queryFn: getReservations,
  });
